import axios from "axios";

export default axios.create({
  baseURL: "https://submit-form.com/2EVM3MuhbW5b8EzX6Tcnc",
  responseType: "json"
});
